import { useIsMobile } from '@findy-code/yuffie/utils/media-query';

import {
  ExternalLinkCard,
  LinkCardBody,
  useExpandableItems,
} from '../../../common';
import { SectionLayoutBase } from '../../../common/section-layout-base.component';
import type { FetchJobDescriptionDetailFindyToolsArticleFragment } from '../../graphql';
import styles from './findy-tools-articles.component.module.scss';

type Props = {
  articles: FetchJobDescriptionDetailFindyToolsArticleFragment[];
};

// TODO: CompanyInterviewsInnerと共通化
const CompanyFindyToolsArticlesInner = ({ articles }: Props) => (
  <ul className={styles.articleList}>
    {articles.map((article) => (
      <li
        className={styles.articleItem}
        data-single-item={articles.length === 1}
        key={`findy-tools-article-${article.id}`}
      >
        <ExternalLinkCard
          body={
            <LinkCardBody
              publishedAt={article.publishedAt}
              title={article.title ?? ''}
            />
          }
          href={article.articleUrl}
          thumbnailImage={
            <img
              alt="Findy Tools記事見出し"
              className={styles.articleImage}
              src={article.thumbnailUrl}
            />
          }
        />
      </li>
    ))}
  </ul>
);

export const CompanyFindyToolsArticles = ({ articles }: Props) => {
  const isMobile = useIsMobile();
  const { displayItems, ExpandButton } = useExpandableItems(
    articles,
    isMobile ? articles.length : 3,
    'Findy Toolsの記事をもっとみる'
  );
  return (
    <SectionLayoutBase
      heading={{ title: '開発環境や技術選定等に関する特集記事' }}
      id="company-findy-tools"
    >
      <CompanyFindyToolsArticlesInner articles={displayItems} />
      <div className={styles.mobileHidden}>
        <ExpandButton />
      </div>
    </SectionLayoutBase>
  );
};
